


























































































































































































































































import { WhatsappDetailItemInfo } from '@/store/whatsapp/statistic/types';
import { dateFilter } from '@/utils/date-util';
import { notifyError, notifySuccess } from '@/utils/notify-helper';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { colorClassByStatus, formatAsJson } from '@/utils/page-utils';
import axios, { AxiosResponse } from 'axios';
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";
import {InputWings, TextareaWings} from "wings-ui-components";

@Component({ components: {InputWings, TextareaWings}, filters: {dateFilter}, methods: {formatAsJson, colorClassByStatus} })
export default class WhatsappDetailInfo extends Vue {
  @Action('getWhatsappStatisticDetailInfo') actionGetItem: any;
  @Action('resendWhatsappMessage') actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  private messageInfo: WhatsappDetailItemInfo = new WhatsappDetailItemInfo();
  private transport = MsgTransports.WHATSAPP;
  private logObject: ActionLog = {};

  async created(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const response: AxiosResponse<WhatsappDetailItemInfo> = await this.actionGetItem(this.$route.params.id);
      await this.actionLog(this.logObject);
      this.messageInfo = response.data;
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  back(): void {
    this.$router.push('/whatsapp/detail/');
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const response: AxiosResponse<{status: string}> = await this.actionResendMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
      if (response.data.status === 'Success') {
        notifySuccess(<string> this.$t('dialog.resend'));
      } else {
        notifyError();
      }
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  get isShowFinanceInfo(): boolean {
    return localStorage.getItem('show-finance-info') === 'true';
  }

  private goToTheLink(link: string): void {
    window.location.href = link;
  }
}
